(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["optisave-prescription-configurator"] && !Shopify.designMode) return;
  try {
    class OptisaveRxConfigurator extends HTMLElement {
    connectedCallback() {
      this.dataset.rootUrl = `${(this.dataset.rootUrl || '/').replace(/\/+$/, '')}/`;
      this.dialog = this.querySelector('[data-rx-dialog]');
      this.form = document.getElementById(this.dataset.formId);
      this.step = 1;
      this.configured = false;
      this.submitting = false;
      this.configurationId = '';
      this.requestedFeatures = new Set();
      this.packageHandle = '';
      this.expandedPackages = false;
      this.framePrices = JSON.parse(this.querySelector('[data-rx-frame-prices]')?.textContent || '{}');
      this.openButtons = this.querySelectorAll('[data-rx-open]');
      this.error = this.querySelector('[data-rx-error]');
      this.fileInput = this.querySelector('[data-rx-file]');
      this.querySelector('[data-rx-package-toggle]')?.addEventListener('click', () => {
        this.expandedPackages = !this.expandedPackages;
        this.renderPackageOptions();
      });
      this.openButtons.forEach((button) => button.addEventListener('click', () => this.open()));
      this.querySelector('[data-rx-close]')?.addEventListener('click', () => this.close());
      this.querySelector('[data-rx-back]')?.addEventListener('click', () => this.back());
      this.querySelector('[data-rx-next]')?.addEventListener('click', () => this.next());
      this.querySelector('[data-rx-submit]')?.addEventListener('click', () => this.finalize());
      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });
      this.querySelectorAll('input[type="radio"]').forEach((input) => {
        input.addEventListener('change', () => this.handleChoice(input));
      });
      this.querySelectorAll('[data-rx-upgrade]').forEach((input) => {
        input.addEventListener('change', () => {
          this.syncProtectiveOptions();
          this.clearError();
        });
      });
      this.querySelectorAll('[data-rx-protective]').forEach((input) => {
        input.addEventListener('change', () => { this.clearError(); this.updateRunningTotal(); });
      });
      this.querySelectorAll('[data-rx-feature]').forEach((input) => {
        input.addEventListener('change', () => {
          if (input.checked) this.requestedFeatures.add(input.value);
          else this.requestedFeatures.delete(input.value);
          this.syncLensAvailability();
          this.clearError();
        });
      });
      this.querySelectorAll('[data-rx-field]').forEach((input) => {
        input.addEventListener('input', () => this.clearError());
      });
      this.fileInput?.addEventListener('change', () => {
        this.clearError();
        const file = this.fileInput.files?.[0];
        const name = this.querySelector('[data-rx-file-name]');
        if (name) name.textContent = file?.name || '';
      });
      this.form?.addEventListener('submit', (event) => this.handleFormSubmit(event), true);
      this.form?.addEventListener('change', () => this.updateRunningTotal());
      this.syncLensAvailability();
      this.syncTreatmentFamily();
      this.syncProtectiveOptions();
      this.update();
    }

    get prescriptionAllowed() {
      return this.dataset.rxAllowed === 'true';
    }

    get use() {
      const selected = this.querySelector('input[name^="rx-use-"]:checked')?.value || '';
      return this.prescriptionAllowed || ['frame-only', 'non-prescription'].includes(selected) ? selected : '';
    }

    get method() {
      return this.querySelector('input[name^="rx-method-"]:checked')?.value || '';
    }

    get lensInput() {
      return this.querySelector('input[name^="rx-lens-"]:checked');
    }

    get lensFamily() {
      return this.querySelector('input[name^="rx-new-family-"]:checked')?.value || '';
    }

    get isLegacyLens() {
      return this.lensInput?.closest('[data-rx-lens-card]')?.dataset.catalogMode === 'legacy';
    }

    get upgradeInputs() {
      return Array.from(this.querySelectorAll('[data-rx-upgrade]:checked')).filter((input) => !input.disabled);
    }

    get protectiveInputs() {
      return Array.from(this.querySelectorAll('[data-rx-protective]:checked')).filter((input) => !input.disabled);
    }

    get treatmentFamily() {
      return this.querySelector('input[name^="rx-treatment-family-"]:checked')?.value || 'clear';
    }

    get requiresPrescription() {
      return this.prescriptionAllowed && ['distance', 'reading', 'multifocal', 'occupational'].includes(this.use);
    }

    get pdType() {
      return this.querySelector('input[name^="rx-pd-type-"]:checked')?.value || 'single';
    }

    open() {
      if (!this.dialog) return;
      this.clearError();
      if (!this.dialog.open) {
        this.dialog.showModal();
        this.emitStepEvent('optisave_configurator_open');
      }
      requestAnimationFrame(() => this.querySelector(`[data-rx-step="${this.step}"] input`)?.focus());
    }

    close() {
      this.dialog?.close();
    }

    handleChoice(input) {
      if (input.name.startsWith('rx-method-')) {
        if (!this.prescriptionAllowed) return;
        const upload = input.value === 'upload';
        const manual = input.value === 'manual';
        this.querySelector('[data-rx-upload-panel]').hidden = !upload;
        this.querySelector('[data-rx-manual-panel]').hidden = !manual;
        this.querySelector('[data-rx-pd-panel]').hidden = !(upload || manual);
        if (this.fileInput) this.fileInput.disabled = !upload;
      }
      if (input.name.startsWith('rx-pd-type-')) {
        const dual = input.value === 'dual';
        this.querySelector('[data-rx-pd-single]').hidden = dual;
        this.querySelector('[data-rx-pd-dual]').hidden = !dual;
      }
      if (input.name.startsWith('rx-use-')) {
        const needsAdd = ['reading', 'multifocal', 'occupational'].includes(input.value);
        this.querySelectorAll('[data-rx-add-heading], [data-rx-add-cell]').forEach((cell) => {
          cell.hidden = !needsAdd;
        });
        this.syncLensAvailability();
      }
      if (input.name.startsWith('rx-new-family-')) {
        const notice = this.querySelector('[data-rx-style-notice]');
        notice.hidden = this.requestedFeatures.size === 0;
        notice.textContent = this.dataset.labelStyleChanged;
        this.requestedFeatures.clear();
        this.packageHandle = '';
        this.syncLensAvailability();
      }
      if (input.name.startsWith('rx-lens-')) this.syncProtectiveOptions();
      if (input.name.startsWith('rx-treatment-family-')) this.syncTreatmentFamily();
      this.clearError();
    }

    lensStyle(input) {
      return input?.dataset.lensFamily === 'blue-light' ? 'clear' : input?.dataset.lensFamily;
    }

    featureKeys(input) {
      const text = [input?.dataset.lensTitle, input?.dataset.lensFeatures, input?.dataset.lensFamily].join(' ').toLowerCase();
      return new Set([
        /blue[ -](light|violet)|blueguard/.test(text) && 'blue-light',
        /scratch/.test(text) && 'scratch',
        /anti[ -]reflect|reduced reflections/.test(text) && 'anti-reflective',
        /easy[ -](to[ -])?clean/.test(text) && 'easy-clean',
        /polari[sz]ed/.test(text) && 'polarised',
        /gradient/.test(text) && 'gradient'
      ].filter(Boolean));
    }

    serviceForFeature(feature) {
      const input = this.querySelector(`[data-rx-protective][data-protective-kind="${feature}"]`);
      return input?.closest('[data-rx-protective-card]')?.dataset.baseDisabled === 'false' ? input : null;
    }

    canProvideFeature(input, feature) {
      if (this.featureKeys(input).has(feature)) return true;
      return Boolean(this.serviceForFeature(feature)) &&
        (feature === 'scratch' || (feature === 'blue-light' && this.lensStyle(input) === 'clear'));
    }

    matchingLensInputs(features = this.requestedFeatures) {
      return Array.from(this.querySelectorAll('[data-catalog-mode="new"] input[name^="rx-lens-"]')).filter((input) => {
        const uses = input.closest('[data-rx-lens-card]').dataset.lensUses.split(' ');
        return !input.disabled && input.dataset.pricePending !== 'true' && uses.includes(this.use) &&
          this.lensStyle(input) === this.lensFamily && [...features].every((feature) => this.canProvideFeature(input, feature));
      });
    }

    featureSurcharge(input, features = this.requestedFeatures) {
      return [...features].reduce((sum, feature) => {
        if (this.featureKeys(input).has(feature)) return sum;
        const service = this.serviceForFeature(feature);
        return sum + Number(service?.dataset.protectivePrice || 0);
      }, 0);
    }

    featureLabel(feature) {
      return {
        'blue-light': this.dataset.labelBlueLight, scratch: this.dataset.labelScratch,
        'anti-reflective': this.dataset.labelAntiReflective, 'easy-clean': this.dataset.labelEasyClean,
        polarised: this.dataset.labelPolarised, gradient: this.dataset.labelGradient
      }[feature];
    }

    renderPackageOptions() {
      const matches = this.matchingLensInputs();
      const groups = new Map();
      for (const input of matches) {
        const handle = input.dataset.lensProductHandle;
        if (!groups.has(handle)) groups.set(handle, []);
        groups.get(handle).push(input);
      }
      if (this.lensInput && !matches.includes(this.lensInput)) this.lensInput.checked = false;
      if (!groups.has(this.packageHandle)) this.packageHandle = '';
      if (this.lensInput) this.packageHandle = this.lensInput.dataset.lensProductHandle;
      const total = (input) => Number(input.dataset.lensPrice) + this.featureSurcharge(input);
      const sorted = [...groups.entries()].sort((a, b) => Math.min(...a[1].map(total)) - Math.min(...b[1].map(total)));
      const fieldset = this.querySelector('[data-rx-packages]');
      fieldset.querySelectorAll('label').forEach((label) => label.remove());
      let visible = sorted;
      if (!this.expandedPackages && sorted.length > 3) {
        const preferred = this.lensFamily === 'clear' && this.requestedFeatures.size === 0
          ? ['single-vision-lenses-standard-plus', 'single-vision-lenses-advanced', 'zeiss-single-vision-lenses-standard']
          : [];
        visible = preferred.map((handle) => sorted.find(([key]) => key === handle)).filter(Boolean);
        for (const entry of sorted) {
          if (visible.length >= 3) break;
          if (!visible.some(([key]) => key === entry[0])) visible.push(entry);
        }
        if (this.packageHandle && !visible.some(([key]) => key === this.packageHandle)) {
          visible[visible.length - 1] = sorted.find(([key]) => key === this.packageHandle);
        }
      }
      const toggle = this.querySelector('[data-rx-package-toggle]');
      toggle.hidden = sorted.length <= 3;
      toggle.setAttribute('aria-expanded', String(this.expandedPackages));
      toggle.textContent = this.expandedPackages ? 'Show fewer packages' : `Show all ${sorted.length} matching packages`;
      for (const [handle, variants] of visible) {
        const first = variants[0];
        const card = document.createElement('label');
        card.className = 'optisave-rx__choice';
        const radio = document.createElement('input');
        radio.type = 'radio';
        radio.name = `rx-package-${this.dataset.productId}`;
        radio.value = handle;
        radio.checked = this.packageHandle === handle;
        const copy = document.createElement('span');
        copy.className = 'optisave-rx__choice-copy';
        const title = document.createElement('strong');
        title.textContent = first.dataset.lensDesign;
        const meta = document.createElement('small');
        meta.textContent = [first.dataset.lensVendor, first.dataset.lensIndex === 'As listed' ? '' : first.dataset.lensIndex + ' index'].filter(Boolean).join(' · ');
        const features = document.createElement('span');
        features.className = 'optisave-rx__option-description';
        const keys = [...this.featureKeys(first)].filter((key) => key !== 'gradient');
        features.textContent = keys.length ? this.dataset.labelIncludedPrefix + ' ' + keys.map((key) => this.featureLabel(key)).join(' · ') : '';
        const added = [...this.requestedFeatures].filter((key) => !this.featureKeys(first).has(key));
        const addonCopy = document.createElement('span');
        addonCopy.className = 'optisave-rx__option-description';
        if (added.length) addonCopy.textContent = `${this.dataset.labelAddonsPrice}: ${added.map((key) => this.featureLabel(key)).join(' · ')} (+${this.formatMoney(this.featureSurcharge(first))})`;
        const price = document.createElement('span');
        price.className = 'optisave-rx__price';
        const costs = variants.map(total);
        price.textContent = `${Math.min(...costs) !== Math.max(...costs) ? this.dataset.labelFrom + ' ' : ''}+${this.formatMoney(Math.min(...costs))}`;
        copy.append(title, meta, features, addonCopy);
        card.append(radio, copy, price);
        radio.addEventListener('change', () => {
          this.querySelectorAll('input[name^="rx-lens-"]').forEach((input) => { input.checked = false; });
          this.packageHandle = handle;
          if (variants.length === 1) variants[0].checked = true;
          this.renderColourOptions(variants);
          this.syncProtectiveOptions();
          this.syncFeatureControls();
          this.clearError();
        });
        fieldset.append(card);
      }
      this.querySelector('[data-rx-match-count]').textContent = !this.expandedPackages && groups.size > 3 ? `${visible.length} matching packages shown · ${groups.size} available` : (groups.size === 1 ? this.dataset.labelMatchSingle : this.dataset.labelMatchCount.replace('[count]', groups.size));
      this.querySelector('[data-rx-no-matches]').hidden = groups.size > 0;
      this.renderColourOptions(groups.get(this.packageHandle) || []);
      this.syncFeatureControls();
    }

    renderColourOptions(variants) {
      const panel = this.querySelector('[data-rx-colours]');
      panel.replaceChildren();
      const needsChoice = variants.length > 1 || (variants.length === 1 && variants[0].dataset.lensVariantTitle !== 'Default Title');
      panel.hidden = !this.packageHandle || !needsChoice;
      if (panel.hidden) return;
      const fieldset = document.createElement('fieldset');
      const legend = document.createElement('legend');
      legend.textContent = this.dataset.labelColour;
      fieldset.append(legend);
      for (const variant of variants) {
        const label = document.createElement('label');
        label.className = 'optisave-rx__choice';
        const radio = document.createElement('input');
        radio.type = 'radio';
        radio.name = `rx-colour-${this.dataset.productId}`;
        radio.value = variant.value;
        radio.checked = variant.checked;
        const text = document.createElement('span');
        text.textContent = variant.dataset.lensVariantTitle;
        radio.addEventListener('change', () => {
          variant.checked = true;
          this.syncProtectiveOptions();
          this.syncFeatureControls();
          this.clearError();
        });
        label.append(radio, text);
        fieldset.append(label);
      }
      panel.append(fieldset);
    }

    syncFeatureControls() {
      this.querySelectorAll('[data-rx-feature]').forEach((control) => {
        const feature = control.value;
        control.checked = this.requestedFeatures.has(feature);
        const required = new Set([...this.requestedFeatures, feature]);
        const matches = this.matchingLensInputs(required);
        const available = matches.length > 0;
        control.disabled = !control.checked && !available;
        const card = control.closest('[data-rx-feature-card]');
        card.classList.toggle('is-incompatible', control.disabled);
        const note = card.querySelector('[data-rx-feature-note]');
        const price = card.querySelector('[data-rx-feature-price]');
        const selected = this.lensInput;
        const service = this.serviceForFeature(feature);
        price.hidden = !available;
        price.textContent = '';
        if (!available) {
          note.textContent = this.dataset.labelFeatureUnavailable;
        } else if (selected && this.featureKeys(selected).has(feature)) {
          price.textContent = this.dataset.labelFeatureIncluded.replace('[price]', this.formatMoney(0));
          note.textContent = this.dataset.labelFeatureSelectedNote;
        } else if (service && (selected ? matches.includes(selected) : matches.some((input) => !this.featureKeys(input).has(feature)))) {
          price.textContent = this.dataset.labelFeatureAddon.replace('[price]', this.formatMoney(Number(service.dataset.protectivePrice)));
          note.textContent = selected ? this.dataset.labelExtra : this.dataset.labelFeatureAddonNote;
        } else {
          const minimum = Math.min(...matches.map((input) => Number(input.dataset.lensPrice) + this.featureSurcharge(input, required)));
          price.textContent = this.dataset.labelFeaturePackageFrom.replace('[price]', this.formatMoney(minimum));
          note.textContent = selected ? this.dataset.labelFeatureSwitchNote : this.dataset.labelFeaturePackageNote;
        }
      });
    }

    updateRunningTotal() {
      const lens = this.use === 'frame-only' ? null : this.lensInput;
      const lensPrice = Number(lens?.dataset.lensPrice || 0);
      const extras = lens ? this.protectiveInputs.reduce((sum, input) => sum + Number(input.dataset.protectivePrice), 0)
        + (this.isLegacyLens ? this.upgradeInputs.reduce((sum, input) => sum + Number(input.dataset.upgradePrice), 0) : 0) : 0;
      const variantId = this.form?.querySelector('[name="id"]')?.value;
      const frame = Number(this.framePrices[variantId] ?? this.querySelector('[data-rx-frame-price]')?.dataset.rxFramePrice ?? 0);
      const frameLabel = this.querySelector('[data-rx-frame-price]');
      if (frameLabel) frameLabel.textContent = this.formatMoney(frame);
      const frameOnly = this.querySelector('[data-rx-frame-only-price]');
      if (frameOnly) frameOnly.textContent = this.formatMoney(frame);
      const example = this.querySelector('[data-rx-pair-example]');
      if (example) example.querySelector('[data-rx-pair-example-price]').textContent = this.formatMoney(frame + Number(example.dataset.lensPrice));
      const summary = this.querySelector('[data-rx-running-summary]');
      if (summary) {
        summary.replaceChildren();
        if (lens) {
          for (const [label, price] of [[this.dataset.labelPackagePrice, lensPrice], [this.dataset.labelAddonsPrice, extras], [this.dataset.labelPairTotal, frame + lensPrice + extras]]) {
            const row = document.createElement('div');
            const term = document.createElement('dt');
            const value = document.createElement('dd');
            term.textContent = label;
            value.textContent = this.formatMoney(price);
            row.append(term, value);
            summary.append(row);
          }
        }
      }
      const footer = this.querySelector('[data-rx-footer-total]');
      if (footer) {
        footer.hidden = !lens;
        footer.textContent = lens ? `${this.dataset.labelPairTotal} ${this.formatMoney(frame + lensPrice + extras)}` : '';
      }
    }

    syncLensAvailability() {
      const legacyMode = ['multifocal', 'occupational'].includes(this.use);
      const newCatalog = this.querySelector('[data-rx-new-catalog]');
      const legacyCatalog = this.querySelector('[data-rx-legacy-catalog]');
      if (newCatalog) newCatalog.hidden = legacyMode;
      if (legacyCatalog) legacyCatalog.hidden = !legacyMode;
      const treatments = this.querySelector('[data-rx-legacy-treatment]');
      if (treatments) treatments.hidden = this.use === 'occupational';
      if (this.use === 'occupational') {
        const clear = this.querySelector('input[name^="rx-treatment-family-"][value="clear"]');
        if (clear) clear.checked = true;
      }
      this.querySelectorAll('[data-rx-lens-card]').forEach((card) => {
        const uses = (card.dataset.lensUses || '').split(' ').filter(Boolean);
        const modeMatches = legacyMode ? card.dataset.catalogMode === 'legacy' : card.dataset.catalogMode === 'new';
        const familyMatches = card.dataset.catalogMode !== 'new' || this.lensStyle(card) === this.lensFamily;
        const hidden = !modeMatches || !uses.includes(this.use) || !familyMatches;
        card.hidden = hidden;
        const input = card.querySelector('input[name^="rx-lens-"]');
        if (hidden && input) input.checked = false;
      });
      if (legacyMode) {
        this.syncTreatmentFamily();
      } else {
        this.querySelectorAll('[data-rx-upgrade]').forEach((upgrade) => {
          upgrade.checked = false;
        });
        this.renderPackageOptions();
      }
      this.syncProtectiveOptions();
    }

    syncTreatmentFamily() {
      const family = this.treatmentFamily;
      this.querySelectorAll('[data-rx-treatment-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.rxTreatmentPanel !== family;
      });
      this.querySelectorAll('[data-rx-upgrade]').forEach((upgrade) => {
        if (family === 'clear' || upgrade.dataset.upgradeFamily !== family) upgrade.checked = false;
      });
      if (family !== 'clear') {
        const available = Array.from(this.querySelectorAll(`[data-rx-upgrade][data-upgrade-family="${family}"]:not(:disabled)`));
        if (available.length === 1 && !available[0].checked) available[0].checked = true;
      }
      this.syncProtectiveOptions();
    }

    includedProtectionLabels() {
      const lens = this.lensInput;
      if (!lens) return [];
      const selectedFamily = this.isLegacyLens ? this.treatmentFamily : this.lensFamily;
      const text = [
        lens.dataset.lensTitle,
        lens.dataset.lensFeatures,
        lens.dataset.lensDesign,
        lens.dataset.lensFamily,
        ...this.upgradeInputs.map((input) => input.dataset.upgradeTitle)
      ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();
      const labels = [];
      const add = (condition, label) => {
        if (condition && label && !labels.includes(label)) labels.push(label);
      };
      add(text.includes('scratch'), this.dataset.labelScratch);
      add(text.includes('anti-reflect') || text.includes('anti reflect') || text.includes('reduced reflection'), this.dataset.labelAntiReflective);
      add(selectedFamily === 'blue-light' || text.includes('blue-light') || text.includes('blue light') || text.includes('blue-violet') || text.includes('blue violet') || text.includes('blueguard'), this.dataset.labelBlueLight);
      add(text.includes('uv') || text.includes('uva') || text.includes('uvb'), this.dataset.labelUv);
      add(text.includes('water') || text.includes('hydrophobic'), this.dataset.labelWater);
      add(text.includes('easy-clean') || text.includes('easy clean') || text.includes('easy-to-clean'), this.dataset.labelEasyClean);
      add(text.includes('dust') || text.includes('smudge') || text.includes('anti-static'), this.dataset.labelDust);
      add(text.includes('polarised') || text.includes('polarized'), this.dataset.labelPolarised);
      add(selectedFamily === 'photochromic' || text.includes('photochromic') || text.includes('photofusion'), this.dataset.labelPhotochromic);
      return labels;
    }

    protectiveKindIsIncluded(kind) {
      const labels = this.includedProtectionLabels();
      if (kind === 'scratch') return labels.includes(this.dataset.labelScratch);
      if (kind === 'blue-light') return labels.includes(this.dataset.labelBlueLight);
      return false;
    }

    syncProtectiveOptions() {
      const panel = this.querySelector('[data-rx-protection]');
      if (!panel) return;
      panel.hidden = this.use === 'frame-only';
      const lens = this.lensInput;
      const legacyMode = ['multifocal', 'occupational'].includes(this.use);
      panel.hidden = this.use === 'frame-only' || (!legacyMode && !lens);
      this.querySelector('[data-rx-protection-heading]').hidden = !legacyMode;
      this.querySelector('.optisave-rx__protective-options').hidden = !legacyMode;
      this.querySelector('[data-rx-protection-note]').hidden = !legacyMode;
      const labels = this.includedProtectionLabels();
      const chips = this.querySelector('[data-rx-included-protection]');
      if (chips) {
        chips.replaceChildren();
        const chipLabels = !lens ? [this.dataset.labelSelectLens] : labels.length ? labels : [this.dataset.labelNone];
        chipLabels.forEach((label) => {
          const chip = document.createElement('span');
          chip.textContent = label;
          chips.append(chip);
        });
      }
      this.querySelectorAll('[data-rx-protective-card]').forEach((card) => {
        const input = card.querySelector('[data-rx-protective]');
        const status = card.querySelector('[data-rx-protective-status]');
        if (!input || !status) return;
        const baseDisabled = card.dataset.baseDisabled === 'true';
        const kind = input.dataset.protectiveKind || '';
        const included = Boolean(lens) && this.protectiveKindIsIncluded(kind);
        const activeFamily = this.isLegacyLens ? this.treatmentFamily : this.lensFamily;
        const compatible = kind !== 'blue-light' || activeFamily === 'clear' || included;
        input.disabled = baseDisabled || !lens || included || !compatible;
        if (!legacyMode) input.checked = !input.disabled && this.requestedFeatures.has(kind);
        else if (input.disabled) input.checked = false;
        card.classList.toggle('is-included', included);
        card.classList.toggle('is-incompatible', !included && (baseDisabled || !lens || !compatible));
        if (baseDisabled) {
          status.textContent = this.dataset.labelSoldOut;
        } else if (!lens) {
          status.textContent = this.dataset.labelSelectLens;
        } else if (included) {
          status.textContent = this.dataset.labelIncluded;
        } else if (!compatible) {
          status.textContent = this.dataset.labelIncompatible;
        } else {
          status.textContent = `+${this.formatMoney(Number(input.dataset.protectivePrice || 0))}`;
        }
      });
      this.updateRunningTotal();
    }

    next() {
      if (!this.validateStep()) return;
      this.clearError();
      this.emitStepEvent('optisave_configurator_step_complete');
      if (this.step === 1 && this.use === 'frame-only') {
        this.step = 4;
      } else if (this.step === 1 && this.use === 'non-prescription') {
        this.step = 3;
      } else {
        this.step = Math.min(4, this.step + 1);
      }
      this.update();
    }

    back() {
      if (this.step === 4 && this.use === 'frame-only') {
        this.step = 1;
      } else if (this.step === 4 && this.use === 'non-prescription') {
        this.step = 3;
      } else if (this.step === 3 && this.use === 'non-prescription') {
        this.step = 1;
      } else {
        this.step = Math.max(1, this.step - 1);
      }
      this.clearError();
      this.update();
    }

    validateStep() {
      if (this.step === 1 && !this.use) return this.showError(this.dataset.errorUse);
      if (this.step === 2) {
        if (!this.method) return this.showError(this.dataset.errorMethod);
        if (this.method === 'upload') {
          const file = this.fileInput?.files?.[0];
          if (!file) return this.showError(this.dataset.errorUpload);
          if (file.size > 10485760) return this.showError(this.dataset.errorFileSize);
          const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];
          if (!allowedTypes.includes(file.type)) return this.showError(this.dataset.errorUpload);
        }
        if (this.method === 'manual' && !this.validateManual()) return false;
        if ((this.method === 'manual' || this.method === 'upload') && !this.validatePd()) return false;
      }
      if (this.step === 3) {
        if (this.use !== 'multifocal' && !this.lensFamily) return this.showError(this.dataset.errorLensFamily);
        if (!this.lensInput) return this.showError(this.packageHandle && this.use !== 'multifocal' && this.use !== 'occupational' ? this.dataset.labelChooseColour : this.dataset.errorLens);
        if (this.lensInput.dataset.pricePending === 'true') return this.showError(this.dataset.errorPricing);
        if (this.isLegacyLens && this.treatmentFamily !== 'clear' && this.upgradeInputs.length !== 1) {
          return this.showError(this.dataset.errorTreatment);
        }
        if (this.isLegacyLens && this.upgradeInputs.some((input) => input.dataset.pricePending === 'true')) {
          return this.showError(this.dataset.errorPricing);
        }
      }
      return true;
    }

    validateManual() {
      const required = ['od_sph', 'os_sph'];
      if (this.use === 'multifocal' || this.use === 'occupational') required.push('od_add', 'os_add');
      for (const key of required) {
        const input = this.querySelector(`[data-rx-field="${key}"]`);
        if (!input?.value || !input.checkValidity()) return this.showError(this.dataset.errorManual);
      }
      for (const eye of ['od', 'os']) {
        const cyl = this.querySelector(`[data-rx-field="${eye}_cyl"]`);
        const axis = this.querySelector(`[data-rx-field="${eye}_axis"]`);
        if (cyl?.value && !cyl.checkValidity()) return this.showError(this.dataset.errorManual);
        if (axis?.value && !axis.checkValidity()) return this.showError(this.dataset.errorManual);
        const hasCylinder = Boolean(cyl?.value) && Number(cyl.value) !== 0;
        if (hasCylinder && !axis?.value) {
          return this.showError(this.dataset.errorManual);
        }
        if (!hasCylinder && axis?.value) {
          return this.showError(this.dataset.errorManual);
        }
        const prism = this.querySelector(`[data-rx-field="${eye}_prism"]`);
        const base = this.querySelector(`[data-rx-field="${eye}_base"]`);
        if (prism?.value && (!prism.checkValidity() || !base?.value)) return this.showError(this.dataset.errorManual);
        if (!prism?.value && base?.value) return this.showError(this.dataset.errorManual);
      }
      return true;
    }

    validatePd() {
      if (this.pdType === 'single') {
        const pd = this.querySelector('[data-rx-field="pd_single"]');
        if (!pd?.value || !pd.checkValidity()) return this.showError(this.dataset.errorPd);
      } else {
        for (const key of ['pd_right', 'pd_left']) {
          const pd = this.querySelector(`[data-rx-field="${key}"]`);
          if (!pd?.value || !pd.checkValidity()) return this.showError(this.dataset.errorPd);
        }
      }
      return true;
    }

    update() {
      this.querySelectorAll('[data-rx-step]').forEach((section) => {
        section.hidden = Number(section.dataset.rxStep) !== this.step;
      });
      this.querySelectorAll('[data-rx-progress]').forEach((item) => {
        const step = Number(item.dataset.rxProgress);
        item.classList.toggle('is-active', step === this.step);
        item.classList.toggle('is-complete', step < this.step);
      });
      const back = this.querySelector('[data-rx-back]');
      const next = this.querySelector('[data-rx-next]');
      const submit = this.querySelector('[data-rx-submit]');
      back.hidden = this.step === 1;
      next.hidden = this.step === 4;
      submit.hidden = this.step !== 4;
      if (this.step === 3) {
        this.syncLensAvailability();
        this.syncTreatmentFamily();
      }
      if (this.step === 4) this.renderReview();
      this.updateRunningTotal();
      this.querySelector(`[data-rx-step="${this.step}"]`)?.scrollIntoView({ block: 'nearest' });
    }

    renderReview() {
      const useInput = this.querySelector('input[name^="rx-use-"]:checked');
      const methodInput = this.querySelector('input[name^="rx-method-"]:checked');
      const lens = this.lensInput;
      const upgrades = this.isLegacyLens ? this.upgradeInputs : [];
      const protective = this.protectiveInputs;
      const includedProtection = this.includedProtectionLabels();
      this.querySelector('[data-rx-review-use]').textContent =
        useInput?.closest('label')?.querySelector('strong')?.textContent?.trim() || '—';
      this.querySelector('[data-rx-review-method]').textContent =
        this.use === 'frame-only' || this.use === 'non-prescription'
          ? this.dataset.labelNotRequired
          : methodInput?.value === 'upload'
            ? this.dataset.labelUpload
            : methodInput?.value === 'later'
              ? 'Send after order'
              : this.dataset.labelManual;
      this.querySelector('[data-rx-review-prescription]').textContent = this.prescriptionSummary();
      this.querySelector('[data-rx-review-lens]').textContent =
        this.use === 'frame-only' ? this.dataset.labelNotRequired : lens?.dataset.lensTitle || '—';
      this.querySelector('[data-rx-review-brand]').textContent =
        this.use === 'frame-only' ? this.dataset.labelNotRequired : lens?.dataset.lensVendor || 'Optisave optical laboratory';
      this.querySelector('[data-rx-review-family]').textContent =
        this.use === 'frame-only' ? this.dataset.labelNotRequired : this.isLegacyLens ? this.labelForUse() : this.lensFamilyLabel();
      this.querySelector('[data-rx-review-index]').textContent =
        this.use === 'frame-only' ? this.dataset.labelNotRequired : lens?.dataset.lensIndex || '—';
      this.querySelector('[data-rx-review-features]').textContent =
        this.use === 'frame-only' ? this.dataset.labelNotRequired : lens?.dataset.lensFeatures || '—';
      this.querySelector('[data-rx-review-price]').textContent =
        this.use === 'frame-only'
          ? this.dataset.labelNotRequired
          : lens?.closest('label')?.querySelector('.optisave-rx__price')?.textContent?.trim() || '—';
      this.querySelector('[data-rx-review-upgrades]').textContent =
        this.use === 'frame-only'
          ? this.dataset.labelNotRequired
          : !this.isLegacyLens
            ? 'Included in the selected lens option'
            : upgrades.length
            ? upgrades
                .map((input) => {
                  const price = input.closest('label')?.querySelector('.optisave-rx__price')?.textContent?.trim() || '';
                  return `${input.dataset.upgradeTitle} ${price}`.trim();
                })
                .join(' · ')
              : 'Clear · Included';
      this.querySelector('[data-rx-review-included-protection]').textContent =
        this.use === 'frame-only'
          ? this.dataset.labelNotRequired
          : includedProtection.length
            ? includedProtection.join(' · ')
            : this.dataset.labelNone;
      this.querySelector('[data-rx-review-protective]').textContent =
        this.use === 'frame-only'
          ? this.dataset.labelNotRequired
          : protective.length
            ? protective
                .map((input) => `${input.dataset.protectiveTitle} +${this.formatMoney(Number(input.dataset.protectivePrice || 0))}`)
                .join(' · ')
            : this.dataset.labelNone;
      const totalCents = this.use === 'frame-only'
        ? 0
        : Number(lens?.dataset.lensPrice || 0)
          + upgrades.reduce((sum, input) => sum + Number(input.dataset.upgradePrice || 0), 0)
          + protective.reduce((sum, input) => sum + Number(input.dataset.protectivePrice || 0), 0);
      this.querySelector('[data-rx-review-services-total]').textContent =
        this.use === 'frame-only' ? this.dataset.labelNotRequired : this.formatMoney(totalCents);
      const requiresConsent = this.requiresPrescription;
      const consentPanel = this.querySelector('[data-rx-consent-panel]');
      if (consentPanel) consentPanel.hidden = !requiresConsent;
    }

    prescriptionSummary() {
      if (!this.requiresPrescription) return this.dataset.labelNotRequired;
      if (this.method === 'later') return 'Prescription to be supplied after the order is placed';
      const pd = this.pdType === 'single'
        ? this.querySelector('[data-rx-field="pd_single"]')?.value || ''
        : `${this.querySelector('[data-rx-field="pd_right"]')?.value || ''} / ${this.querySelector('[data-rx-field="pd_left"]')?.value || ''}`;
      if (this.method === 'upload') {
        const fileName = this.fileInput?.files?.[0]?.name;
        return fileName ? `${this.dataset.labelUpload}: ${fileName} · PD: ${pd}` : `${this.dataset.labelUpload} · PD: ${pd}`;
      }

      const value = (key) => this.querySelector(`[data-rx-field="${key}"]`)?.value || '';
      const eye = (prefix) => {
        const values = [`SPH ${value(`${prefix}_sph`)}`];
        if (value(`${prefix}_cyl`)) values.push(`CYL ${value(`${prefix}_cyl`)}`);
        if (value(`${prefix}_axis`)) values.push(`AXIS ${value(`${prefix}_axis`)}`);
        if (value(`${prefix}_add`)) values.push(`ADD ${value(`${prefix}_add`)}`);
        if (value(`${prefix}_prism`)) values.push(`Prism ${value(`${prefix}_prism`)} ${value(`${prefix}_base`)}`);
        return values.join(', ');
      };
      return `OD: ${eye('od')} · OS: ${eye('os')} · PD: ${pd}`;
    }

    formatMoney(cents) {
      const currency = globalThis.Shopify?.currency?.active || 'AUD';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', { style: 'currency', currency }).format(cents / 100);
      } catch (_error) {
        return `A$${(cents / 100).toFixed(2)}`;
      }
    }

    finalize() {
      const consent = this.querySelector('[data-rx-consent]');
      const requiresConsent = this.requiresPrescription;
      if (requiresConsent && !consent?.checked) return this.showError(this.dataset.errorConsent);
      if (this.use !== 'frame-only' && (!this.lensInput || this.lensInput.dataset.pricePending === 'true')) {
        return this.showError(this.dataset.errorPricing);
      }
      this.configurationId = globalThis.crypto?.randomUUID?.() || `rx-${Date.now()}-${Math.random().toString(16).slice(2)}`;
      this.writeProperties();
      this.configured = true;
      const selection = this.querySelector('[data-rx-selection]');
      const selectionText = this.querySelector('[data-rx-selection-text]');
      if (selectionText) {
        const lens = this.use === 'frame-only' ? this.dataset.labelNotRequired : this.lensInput?.dataset.lensTitle;
        const upgrades = this.isLegacyLens ? this.upgradeInputs.map((input) => input.dataset.upgradeTitle) : [];
        const protective = this.protectiveInputs.map((input) => input.dataset.protectiveTitle);
        const upgradeSummary = this.use === 'frame-only'
          ? ''
          : this.isLegacyLens
            ? upgrades.length ? ` · ${upgrades.join(', ')}` : ' · Clear'
            : ` · ${this.lensFamilyLabel()}`;
        const protectiveSummary = protective.length ? ` · ${protective.join(', ')}` : '';
        selectionText.textContent = `${this.labelForUse()} · ${lens}${upgradeSummary}${protectiveSummary}`;
      }
      if (selection) selection.hidden = false;
      this.close();
      this.submitConfiguredOrder();
    }

    labelForUse() {
      return this.querySelector('input[name^="rx-use-"]:checked')?.closest('label')?.querySelector('strong')?.textContent?.trim() || '';
    }

    lensFamilyLabel() {
      return this.querySelector('input[name^="rx-new-family-"]:checked')?.closest('label')?.querySelector('strong')?.textContent?.trim() || '';
    }

    writeProperties() {
      this.removeGeneratedProperties();
      this.addProperty('_Rx configuration ID', this.configurationId);
      this.addProperty('_Rx submitted at', new Date().toISOString());
      this.addProperty('Lens use', this.labelForUse());
      this.addProperty('_Ordering market country', this.dataset.marketCountry);
      this.addProperty('_Lens prescription mode', this.use === 'frame-only' ? 'Frame only' : this.requiresPrescription ? 'Prescription' : 'Non-prescription (plano)');
      if (this.fileInput) this.fileInput.disabled = !(this.requiresPrescription && this.method === 'upload');
      if (this.use === 'non-prescription') {
        this.addProperty('_Right SPH', '0.00');
        this.addProperty('_Left SPH', '0.00');
        this.addProperty('_Prescription status', 'Not required - plano lenses');
      }
      this.addProperty('Lens package', this.use === 'frame-only' ? 'Frame only' : this.lensInput?.dataset.lensTitle || '');
      if (this.use !== 'frame-only') {
        const upgrades = this.isLegacyLens ? this.upgradeInputs.map((input) => input.dataset.upgradeTitle) : [];
        const protective = this.protectiveInputs.map((input) => input.dataset.protectiveTitle);
        const treatment = this.isLegacyLens ? this.upgradeInputs[0] : null;
        this.addProperty('Lens design', this.lensInput?.dataset.lensDesign || '');
        this.addProperty('Lens brand', this.lensInput?.dataset.lensVendor || 'Optisave optical laboratory');
        this.addProperty('Lens family', this.isLegacyLens ? this.labelForUse() : this.lensFamilyLabel());
        this.addProperty('Lens index', this.lensInput?.dataset.lensIndex || '');
        this.addProperty('_Lens material', this.lensInput?.dataset.lensMaterial || '');
        this.addProperty('_Lens SKU', this.lensInput?.dataset.lensSku || '');
        this.addProperty('_Lens product handle', this.lensInput?.dataset.lensProductHandle || '');
        this.addProperty('Included lens finish', this.lensInput?.dataset.lensFeatures || '');
        this.addProperty('Primary treatment', this.isLegacyLens ? treatment?.dataset.upgradeTitle || 'Clear' : this.lensFamilyLabel());
        this.addProperty('_Treatment family', this.isLegacyLens ? this.treatmentFamily : this.lensFamily);
        this.addProperty('_Treatment SKU', this.isLegacyLens ? treatment?.dataset.upgradeSku || 'INCLUDED-CLEAR' : 'INCLUDED-IN-LENS-OPTION');
        this.addProperty('Included protection', this.includedProtectionLabels().join(', ') || this.dataset.labelNone);
        this.addProperty('Paid protective add-ons', protective.join(', ') || this.dataset.labelNone);
        this.addProperty('Lens upgrades', [
          this.isLegacyLens ? upgrades.length ? upgrades.join(', ') : 'Clear included' : 'Included in selected lens option',
          protective.length ? protective.join(', ') : ''
        ].filter(Boolean).join('; '));
      }
      if (this.requiresPrescription) {
        const prescriptionMethod = this.method === 'upload' ? this.dataset.labelUpload : this.method === 'later' ? 'Send after order' : this.dataset.labelManual;
        this.addProperty('Prescription method', prescriptionMethod);
        this.addProperty('_Prescription status', this.method === 'later' ? 'Awaiting customer prescription' : 'Provided with order');
        if (this.method === 'upload') {
          this.addProperty('_Prescription file name', this.fileInput?.files?.[0]?.name || '');
        }
        if (this.method === 'manual') {
          const names = {
            od_sph: '_Right SPH',
            od_cyl: '_Right CYL',
            od_axis: '_Right AXIS',
            od_add: '_Right ADD',
            od_prism: '_Right Prism',
            od_base: '_Right Base',
            os_sph: '_Left SPH',
            os_cyl: '_Left CYL',
            os_axis: '_Left AXIS',
            os_add: '_Left ADD',
            os_prism: '_Left Prism',
            os_base: '_Left Base'
          };
          Object.entries(names).forEach(([key, name]) => {
            const input = this.querySelector(`[data-rx-field="${key}"]`);
            if (input?.value) this.addProperty(name, input.value);
          });
        }
        if (this.method !== 'later') {
          this.addProperty('_PD type', this.pdType === 'single' ? 'Single PD' : 'Dual PD');
          if (this.pdType === 'single') {
            this.addProperty('_PD', this.querySelector('[data-rx-field="pd_single"]')?.value || '');
          } else {
            this.addProperty('_Right PD', this.querySelector('[data-rx-field="pd_right"]')?.value || '');
            this.addProperty('_Left PD', this.querySelector('[data-rx-field="pd_left"]')?.value || '');
          }
        }
      }
      if (this.requiresPrescription) {
        this.addProperty('_Prescription consent', 'Confirmed');
      }
    }

    addProperty(name, value) {
      if (!this.form || !value) return;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[${name}]`;
      input.value = value;
      input.dataset.rxGenerated = 'true';
      this.form.append(input);
    }

    removeGeneratedProperties() {
      this.form?.querySelectorAll('[data-rx-generated]').forEach((input) => input.remove());
    }

    handleFormSubmit(event) {
      if (this.submitting) return;
      if (!this.configured) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.open();
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      this.submitConfiguredOrder();
    }

    async submitConfiguredOrder() {
      if (!this.form || this.submitting) return;
      this.submitting = true;
      this.setBusy(true);
      let frameKey = '';
      const serviceKeys = [];
      try {
        const frameData = new FormData(this.form);
        const frameResponse = await fetch(`${this.dataset.rootUrl}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: frameData
        });
        const frameBody = await frameResponse.text();
        if (!frameBody) throw new Error("The frame could not be added to your cart. Please try again.");
        const frame = JSON.parse(frameBody);
        if (!frameResponse.ok) throw new Error(frame.description || frame.message || this.dataset.errorCart);
        frameKey = frame.key;
        if (this.use !== 'frame-only') {
          const quantity = Number(frameData.get('quantity')) || 1;
          const serviceItems = [{
            id: Number(this.lensInput.value.replace(/\D/g, '')),
            quantity,
              parent_line_key: frame.key,
              properties: {
                '_Rx configuration ID': this.configurationId,
                '_Service type': this.isLegacyLens ? 'Prescription lens' : 'Lens option',
                '_Frame product': this.dataset.productTitle,
                '_Frame variant ID': String(frame.variant_id || ''),
                'Lens use': this.labelForUse(),
                'Lens design': this.lensInput.dataset.lensDesign || '',
                'Lens brand': this.lensInput.dataset.lensVendor || 'Optisave optical laboratory',
                'Lens family': this.isLegacyLens ? this.labelForUse() : this.lensFamilyLabel(),
                'Lens index': this.lensInput.dataset.lensIndex || '',
                '_Lens material': this.lensInput.dataset.lensMaterial || '',
                '_Lens SKU': this.lensInput.dataset.lensSku || '',
                '_Lens product handle': this.lensInput.dataset.lensProductHandle || '',
                'Included finish': this.lensInput.dataset.lensFeatures || ''
              }
          }];
          const selectedUpgrades = this.isLegacyLens ? this.upgradeInputs : [];
          selectedUpgrades.forEach((upgrade) => {
            serviceItems.push({
              id: Number(upgrade.value.replace(/\D/g, '')),
              quantity,
              parent_line_key: frame.key,
              properties: {
                '_Rx configuration ID': this.configurationId,
                '_Service type': 'Lens treatment',
                '_Frame product': this.dataset.productTitle,
                '_Frame variant ID': String(frame.variant_id || ''),
                '_Lens package': this.lensInput.dataset.lensTitle || '',
                '_Lens SKU': this.lensInput.dataset.lensSku || '',
                '_Treatment family': upgrade.dataset.upgradeFamily || '',
                '_Treatment SKU': upgrade.dataset.upgradeSku || '',
                'Lens treatment': upgrade.dataset.upgradeTitle || ''
              }
            });
          });
          this.protectiveInputs.forEach((protective) => {
            serviceItems.push({
              id: Number(protective.value.replace(/\D/g, '')),
              quantity,
              parent_line_key: frame.key,
              properties: {
                '_Rx configuration ID': this.configurationId,
                '_Service type': 'Protective lens add-on',
                '_Frame product': this.dataset.productTitle,
                '_Frame variant ID': String(frame.variant_id || ''),
                '_Lens package': this.lensInput.dataset.lensTitle || '',
                '_Lens SKU': this.lensInput.dataset.lensSku || '',
                '_Add-on kind': protective.dataset.protectiveKind || '',
                '_Add-on SKU': protective.dataset.protectiveSku || '',
                'Protective add-on': protective.dataset.protectiveTitle || ''
              }
            });
          });
          serviceItems.forEach((item) => {
            item.properties['_Lens prescription mode'] = this.requiresPrescription ? 'Prescription' : 'Non-prescription (plano)';
            item.properties['_Ordering market country'] = this.dataset.marketCountry;
            if (!this.requiresPrescription) {
              item.properties['_Right SPH'] = '0.00';
              item.properties['_Left SPH'] = '0.00';
            }
          });
          const serviceResponse = await fetch(`${this.dataset.rootUrl}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: serviceItems })
          });
          const serviceBody = await serviceResponse.text();
          if (!serviceBody) throw new Error("The lenses could not be added to your cart. Please try again.");
          const serviceResult = JSON.parse(serviceBody);
          if (!serviceResponse.ok) {
            throw new Error(serviceResult.description || serviceResult.message || this.dataset.errorCart);
          }
          const serviceLines = serviceResult.items || [serviceResult];
          if (serviceLines.length !== serviceItems.length) throw new Error(this.dataset.errorCart);
          serviceLines.forEach((line) => {
            if (line.key) serviceKeys.push(line.key);
            const parentKey = line.parent_relationship?.parent_key || line.parent_relationship?.parent?.key || '';
            if (parentKey !== frame.key) throw new Error(this.dataset.errorCart);
          });
        }
        window.location.assign(`${this.dataset.rootUrl}cart`);
      } catch (error) {
        if (frameKey || serviceKeys.length) {
          const updates = {};
          if (frameKey) updates[frameKey] = 0;
          serviceKeys.forEach((key) => {
            updates[key] = 0;
          });
          await fetch(`${this.dataset.rootUrl}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates })
          }).catch(() => {});
        }
        this.open();
        this.showError(error.message || this.dataset.errorCart);
        this.submitting = false;
        this.setBusy(false);
      }
    }

    setBusy(busy) {
      this.querySelectorAll('button').forEach((button) => {
        button.disabled = busy;
      });
      const nativeButton = this.form?.querySelector('button[name="add"]');
      if (nativeButton) nativeButton.disabled = busy;
    }

    emitStepEvent(name) {
      if (!globalThis.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return;
      globalThis.Shopify?.analytics?.publish?.(name, { step: this.step, product_id: this.dataset.productId });
    }

    showError(message) {
      this.emitStepEvent('optisave_configurator_validation_error');
      if (!this.error) return false;
      this.error.textContent = message;
      this.error.hidden = false;
      return false;
    }

    clearError() {
      if (!this.error) return;
      this.error.textContent = '';
      this.error.hidden = true;
    }
  }

  if (!customElements.get('optisave-rx-configurator')) {
    customElements.define('optisave-rx-configurator', OptisaveRxConfigurator);
  }
  } catch(e) { console.error(e); }
})();

})();
